import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import ChipsPropertyScripts from '~/models/scripts/ChipsPropertyScripts';
import { LABELS } from '~/resources/Labels';
import { SIMPLButtonCustomized } from '../button/SIMPLButtonCustumized';

interface Prop {
    chipLabels: ChipsPropertyScripts[];
    filterAtive: boolean;
    showHandler: () => void;
    handlerChips?: () => void;
    clear:()=>void
}

export const SIMPLTableFilter = (props: Prop) => {
    const { chipLabels, filterAtive, showHandler, handlerChips,clear } = props;

    return (
        <div className="flex items-center space-x-2">
            {/* Accessible filter toggle */}
            <button
                className="flex items-center w-[100px] h-[44px] p-2 gap-2 rounded-tl-[2px] rounded-tr-[0px] rounded-br-[0px] rounded-bl-[0px] border border-Primary hover:bg-primary-extra-light cursor-pointer"
                id="testFilter"
                onClick={showHandler}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        showHandler();
                    }
                }}
             
            >
                <span className="text-Primary">{LABELS.Filters}</span>
                <FilterListOutlinedIcon fontSize="small" />
            </button>
            {filterAtive && (
                <>
                    {chipLabels.map((item, index) => (
                        <button
                            key={index}
                            className="flex items-center justify-center w-[91px] h-[32px] gap-[4px] bg-primary-extra-light border border-Primary text-Primary rounded-full hover:bg-[#032636] hover:text-white transition duration-200 cursor-pointer"
                            onClick={handlerChips}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handlerChips?.();
                                }
                            }}
                           
                        >
                            {item.label && (
                                <div className="flex items-center space-x-1">
                                    <p className="font-arial text-base font-normal leading-6 text-center">
                                        {item.label}
                                    </p>
                                    {item.icon && (
                                        <item.icon className="w-[10.5px] h-[10.5px] text-Primary group-hover:bg-primary-dark hover:text-white transition duration-200" />
                                    )}
                                </div>
                            )}
                        </button>
                    ))}
                    {/* Accessible reset filter button */}
                    <div
                        className="ml-10 flex items-center w-[92px] h-[44px] p-[8px] pl-[16px] pr-[16px] gap-[8px] rounded-tl-[2px] rounded-tr-[0px] rounded-br-[0px] rounded-bl-[0px] cursor-pointer">
                        <span style={{display:''}}>
                             <SIMPLButtonCustomized label="Clear All" link  buttonHandlerAction={clear}/>
                        </span>
                       
                    </div>
                </>
            )}
        </div>
    );
};
